(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waiiqi-design-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('.product-sticky-cart');
    if (!bar) return;
    const wrapper = bar.closest('animate-sticky');
    const update = () => {
      const height = wrapper?.hasAttribute('animate') ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--waiiqi-support-offset', `${height}px`);
    };
    if (wrapper) new MutationObserver(update).observe(wrapper, {attributes:true,attributeFilter:['animate']});
    new ResizeObserver(update).observe(bar);
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waiiqi-wave-circle-entry"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindMembership = () => {
      document.querySelectorAll('[data-waiiqi-wave-circle-entry]').forEach(root => {
        if (root.dataset.bound === 'true') return;
        const link = root.querySelector('[data-waiiqi-wave-circle-entry-link]');
        if (!link) return;
        root.dataset.bound = 'true';
        link.addEventListener('click', () => {
          const detail = { locale: root.dataset.locale, productHandle: root.dataset.productHandle, sourcePath: window.location.pathname, placement: 'homepage_wave_circle_entry' };
          root.dataset.lastMeasurementEvent = 'wave_circle_entry_clicked';
          window.dispatchEvent(new CustomEvent('waiiqi:wave_circle_entry_clicked', { detail }));
          document.dispatchEvent(new CustomEvent('waiiqi:wave_circle_entry_clicked', { detail }));
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'waiiqi_wave_circle_entry_clicked', locale: detail.locale, product_handle: detail.productHandle, source_path: detail.sourcePath, placement: detail.placement });
        });
      });
    };
    bindMembership();
    document.addEventListener('shopify:section:load', bindMembership);
  })();
  } catch(e) { console.error(e); }
})();

})();
